import React from 'react';

import BootstrapButton from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Table from 'react-bootstrap/Table';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';

import {Link} from "react-router-dom";


let Page = (props) => {


    return (
        <Container {...props}/>
    );
}


function LinkButton(props) {



    if (props.link) {

        let foo = {};
        foo.to = props.link;
        return (
            <Link {...foo} >
                <BootstrapButton {...props}/>
            </Link>
        );
    }
    
    return (
        <BootstrapButton {...props}/>

    );
 
}

export {Page, Page as PageX, LinkButton as Button, Container, Row, Col, ListGroup, Table, Spinner, Form};
